import { useEffect, useState } from "react";
import { CloseIcon, Dialog, Flex } from "@fluentui/react-northstar";
import AvatarName from "../../AvatarName";
import { useQuery } from "react-query";
import { api_balances_detail_timeline } from "../../../../../features/leave/api";
import { useTranslation } from "react-i18next";
import { I18N_NS_LEAVE } from "../../../../../features/leave/constants";
import DetailedLeaveUserSolde from "./DetailedLeaveUserSolde";
import { _getAllUsers } from "../../../../../api/user";

const DialogSoldeEmployee = ({
    id_employee,
    open,
    onCancelDialog,
    fromCollaborator,
}) => {
    const { t } = useTranslation(I18N_NS_LEAVE);
    const [idEmployeeState, setIdEmployeeState] = useState(id_employee);
    const [simulationData, setSimulationData] = useState({
        month: null,
        year: null,
    });

    useEffect(() => {
        setIdEmployeeState(id_employee);
    }, [id_employee]);

    // ** Query
    // ** Query
    // ** Query

    const {
        data: employee_data,
        isLoading: isLoadingBalanceType,
        isFetching: isFetchingBalanceType,
        refetch: refetchBalanceType,
    } = useQuery(
        [
            "timeline::getSoldeEmployee",
            idEmployeeState ?? id_employee,
            simulationData,
        ],
        () =>
            api_balances_detail_timeline({
                id_user: idEmployeeState ?? id_employee,
                simulationData: simulationData,
            }),
        {
            onSuccess: () => {
                // Optionnel, si besoin de faire autre chose à la réussite
            },
            refetchOnWindowFocus: false,
            enabled: !!idEmployeeState || !!id_employee, // important pour éviter un appel avec undefined
        }
    );
    const {
        data: users,
        isLoading: isLoadingUsers,
        isFetching: isFetchingUsers,
    } = useQuery(["getUsers"], () => _getAllUsers(), {
        refetchOnWindowFocus: false,
        refetchOnMount: true,
        enabled: !fromCollaborator,
    });

    const SimulateLeaveSolde = (value) => {
        setSimulationData(value);
    };

    const onCloseDialog = () => {
        onCancelDialog();
        setIdEmployeeState(null);
        setSimulationData({
            month: null,
            year: null,
        });
    };

    return (
        <Dialog
            open={open}
            header={
                <Flex styles={{ fontWeight: "400" }}>
                    <AvatarName
                        setIdEmployeeState={setIdEmployeeState}
                        id_employee={idEmployeeState ?? id_employee}
                        users={users}
                        image={employee_data?.user?.avatar}
                        name={employee_data?.user?.name}
                        size="largest"
                        jobTitle={employee_data?.user?.job_title}
                        department={employee_data?.user?.department}
                        agency={employee_data?.user?.agency}
                        isLoadingBalanceType={isLoadingBalanceType}
                        isFetchingBalanceType={isFetchingBalanceType}
                        fromCollaborator={fromCollaborator}
                    />
                </Flex>
            }
            content={
                <Flex column gap="gap.medium">
                    {/* // <Content employee_data={employee_data} /> */}
                    <DetailedLeaveUserSolde
                        isLoadingBalanceType={isLoadingBalanceType}
                        isFetchingBalanceType={isFetchingBalanceType}
                        employee_data={employee_data}
                        id_employee={idEmployeeState ?? id_employee}
                        SimulateLeaveSolde={SimulateLeaveSolde}
                        refetchBalanceType={refetchBalanceType}
                    />
                </Flex>
            }
            // confirmButton={configConfirmButton}
            cancelButton={{
                content: t("common.cancel"),
                flat: true,
                onClick: onCloseDialog,
            }}
            onCancel={onCloseDialog}
            headerAction={{
                icon: <CloseIcon />,
                onClick: onCloseDialog,
            }}
            styles={{
                width: "592px",
            }}
        />
    );
};

export default DialogSoldeEmployee;
